<div #gmap class="google-map" >

</div>
